
// import React from 'react';
import { useTranslation } from 'react-i18next';
import './intro.scss';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import gadaLogo from '../../assets/images/intro/gada-logo.png'
import lnetLogoSvg from '../../assets/images/intro/lnet-logo.png'
import walkingPeople from '../../assets/images/intro/wolking_people.png'

import React, { useState } from 'react';
import { useLocation } from 'react-router';
import useDeviceDetection from '../../hooks/useDeviceDetection';


const Preloader = ({ setTl }) => {
  const [t, i18n] = useTranslation();
  const l = useLocation();
  const [proggres, setProggres] = useState(0)
  const deviceType = useDeviceDetection();

  const incProggres = () => setProggres(p => Math.min(p + 23, 99));

  const loadProgressTl = (percents = -30) => {
    if (deviceType?.isMobile){
      percents = 0;
    }

    gsap.timeline()
      .to('.proggres-container', { yPercent: -10 + (percents), opacity: 0, duration: 0.5 })
      .set('.proggres-container', { yPercent: +10 + (percents) })
      .add(incProggres)
      .to('.proggres-container', { yPercent: 0 + (percents), opacity: 1, duration: 0.5 })
      .to('.proggres-container', { backgroundColor: 'none' }, '-=1');
  }



  useGSAP((context) => {

    const tl = gsap.timeline();

    if (l.pathname === "/") {
      setProggres(0);
      gsap.set('.site-wrapper', { maxHeight: '100%' });
      gsap.to('.proggres-container', { opacity: 1, duration: 0.4 });
      gsap.from('#purple-circle',
        { transform: `translateX(${i18n.dir(i18n.resolvedLanguage) == 'rtl'?'-': ''}90vw)`, top: '-4vh', width: '10vh', height: '10vh', duration: 5 }
      )
      tl.fromTo('#lnet-logo-intro',
        { scale: 1, yPercent: 80, opacity: 0 },
        { scale: 1, yPercent: 60, opacity: 1, duration: 0.8 },
        "+=0.5"
      )
        .fromTo('#gada-logo-intro',
          { scale: 1, yPercent: 80, opacity: 0 },
          { yPercent: 60, opacity: 1, duration: 0.8 }
        )
        .to('.logoes-intro-container',
          { scale: deviceType?.isMobile ? 0.6 : 0.3, duration: 0.8 }
        )
        .to('.slogen', {
          opacity: 1, duration: 3
        }, "+=0.1"
        )
        .fromTo('#walking-people',
          { xPercent: 120, opacity: 0 },
          {
            xPercent: deviceType?.isMobile ? -40 : -120, opacity: 1, duration: 5
          },
          "-=3"
        )
        .to('#walking-people', { xPercent: -150, opacity: 0, duration: 0.85 }, '-=0.2')
        .to('.logoes-intro-container', {
          opacity: 0,
          yPercent: -1,
          duration: 1

        }, "-=3")
        .to('#purple-circle', { transform: 'translateX(100vw)', top: '100vh', duration: 3 }, "-=2.5")
        .to('.proggres-container', { yPercent: 1, opacity: 0 }, "-=2.5")
        .to('.slogen', {
          yPercent: 1, opacity: 0,
          duration: 1.3
        }, "-=1.8"
        )

        .add(() => loadProgressTl(), 0.3)
        .add(() => loadProgressTl(), 1.9)
        .add(() => loadProgressTl(), 2.9)
        .add(() => loadProgressTl(), 3.72)
        .add(() => loadProgressTl(), 4.3)
        .add(()=>{
          setTl(true);
  
        }) }

    tl
      .to('.preloader', { opacity: 0, duration: 3 }, '-=0.5')
      .to('.site-wrapper', { maxHeight: 'unset', overflow: 'unset', duration: 0.5 }, "-=1.5")
      .to('.preloader', { display: 'none' })
    


    return () => {
      context.kill();
    }

  }, {dependencies:[deviceType, l]});

  return (
    <div className="preloader">
      <div id="purple-circle"></div>
      <div className='preloader-content-conatiner'>
        <div className="logoes-intro-container">
          <img id="lnet-logo-intro" src={lnetLogoSvg} alt="lnet"  className="no-flip" ></img>
          <img id="gada-logo-intro" src={gadaLogo} alt="GaDa" className="no-flip" ></img>
        </div>
        <h1 className='slogen intro-title'>{t('intro.design-learning-exporience')}</h1>
        <img id="walking-people" src={walkingPeople} alt=''></img>
        <div className='proggres-container intro-title'>{proggres}% </div>
      </div>
    </div>
  );
};
export default Preloader;